import { CurrentUser } from "../../auth";

import { OhCase } from "./model";

export class OhCaseAuthorizer {
    public static isAuthorizedToUpdate = (ohCase: OhCase, user: CurrentUser) =>
        (ohCase.associatedHrIds && ohCase.associatedHrIds.indexOf(user.id) !== -1) ||
        (ohCase.associatedManagerIds && ohCase.associatedManagerIds.indexOf(user.id) !== -1);
}
